import React from 'react';
import { useTranslation } from 'react-i18next';

import ZergRushBanner from '@/common/components/blocks/ZergRushBanner/ZergRushBanner';
import { useAuth } from '@/common/contexts/AuthContext';
import { NotificationsContextProvider } from '@/common/contexts/NotificationsContext/NotificationsContext';
import { SearchContextProvider } from '@/common/contexts/SearchContext';
import { HeaderMenuContextProvider } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import Footer from '../../blocks/Footer/Footer';
import Header from '../../blocks/Header/Header';
import {
  EcatalogLayoutDefaultProps,
  EcatalogLayoutPropTypes,
} from './EcatalogLayout.proptypes';

const EcatalogLayout = ({ children }) => {
  const { t } = useTranslation();
  const { zergRush } = useAuth();

  return (
    <NotificationsContextProvider>
      <HeaderMenuContextProvider>
        <SearchContextProvider>
          <>
            <Header noBottomHeader />
            {zergRush && (
              <ZergRushBanner
                message={t('common:messages:zerg_rush.price_and_stock.banner')}
              />
            )}
            {children}
            <Footer />
          </>
        </SearchContextProvider>
      </HeaderMenuContextProvider>
    </NotificationsContextProvider>
  );
};

EcatalogLayout.defaultProps = {
  ...EcatalogLayoutDefaultProps,
};

EcatalogLayout.propTypes = {
  ...EcatalogLayoutPropTypes,
};

export default EcatalogLayout;
